import styled, { css } from "styled-components";

// div wrapper para darle estilos al componente react-datepicker
export const StylesDatePicker = styled.div`
  .date-input {
    border: none;
    height: ${(props) => props.height || "40px"};
    width: 100%;
    padding: 10px;
    font-size: 16px;
    font-weight: 300;
    font-family: "Nunito";

    ${(props) =>
      (props.twoMonths || props.border) &&
      css`
        border: 1px solid #cccccc;
        font-size: 14px;
        border-radius: 5px;
      `}
  }

  .clear-button::after {
    background-color: transparent !important;
    outline: none;
    content: "×" !important;
    color: black !important;
    font-size: 20px !important;
  }

  .react-datepicker {
    box-shadow: none;
    ${(props) =>
      props.twoMonths &&
      css`
        right: ${props.right || "0px"};
        display: flex;
        position: relative;
        box-shadow: 0 0 0 1px #686868;
        border-radius: 5px;
        z-index: 99;
        font-family: "Nunito";
        min-width: 520px;
        justify-content: center;
        outline: none;
      `}
    /* 
    & :focus {
      outline: none;
      border: none;
    } */

    .react-datepicker__input-container {
      border: none;
      outline: none;
    }

    .react-datepicker-year-header {
      color: #293134 !important;
    }

    .buttons {
      width: 90%;
      position: fixed;
      margin: 10px auto;
    }

    .react-datepicker__navigation {
      ${(props) =>
        props.twoMonths &&
        css`
          top: 55px;
          width: 15px;
          height: 15px;
        `}

      &.react-datepicker__navigation--next,
    &.react-datepicker__navigation--previous {
        width: 15px;
        height: 15px;
      }

      &.react-datepicker__navigation--next {
        border-left-color: #686868 !important;
      }

      &.react-datepicker__navigation--previous {
        border-right-color: #686868 !important;
      }

      &:active {
        outline: none;
      }

      &:focus {
        outline: none;
      }
    }
    /* Mensual */
    .react-datepicker__current-month {
      color: #293134 !important;
    }
    /*     
    .react-datepicker__month {
  
    } */

    .react-datepicker__month-text {
      ${(props) =>
        props.twoMonths &&
        css`
          width: 5rem !important;
        `}
    }

    .react-datepicker__month-container {
      ${(props) =>
        props.twoMonths &&
        css`
          padding-top: 45px;
          width: 100%;
          position: relative;
          z-index: -1;
        `}
    }

    /* Trimestre */
    .react-datepicker__quarter-wrapper {
    }

    /* Anual */
    .react-datepicker__year--container {
      min-width: 170px;
      ${(props) =>
        props.twoMonths &&
        css`
          padding-top: 45px;
        `}

      .react-datepicker__header {
        padding-top: 6px;
      }

      .react-datepicker__year-wrapper {
        display: flex;

        .react-datepicker__year-text {
          width: calc(100% / 3 - 2px * 3);
          margin: 1px;

          &.react-datepicker__year-text--keyboard-selected {
            background-color: #f02a2b !important;
          }
        }
      }
    }

    .react-datepicker__day--today {
      background-color: #cccccc !important;
    }

    .datepicker__year-text--today {
      background-color: #cccccc !important;
    }

    .react-datepicker__year--selected {
      background-color: #f0292a !important;
    }
    .react-datepicker__year-text--selected {
      background-color: #da291c !important;
    }
    .react-datepicker__quarter--selected {
      background-color: #da291c !important;
    }
    .react-datepicker__month--selected {
      background-color: #da291c !important;
    }
    .react-datepicker__month-text--keyboard-selected {
      background-color: #da291c !important;
    }
    .react-datepicker__day--selected {
      background-color: #da291c !important;
    }
    .react-datepicker__day--keyboard-selected {
      background-color: #cccccc !important;
    }

    .react-datepicker__day--in-selecting-range {
      background-color: #da291c !important;
    }
    .react-datepicker__quarter--in-range {
      background-color: #da291c !important;
    }
    .react-datepicker__month--in-range {
      background-color: #da291c !important;
    }
    .react-datepicker__year--in-range {
      background-color: #da291c !important;
    }
    .react-datepicker__day--in-range {
      background-color: #da291c !important;
    }
  }
`;
